import type { HttpRequest } from '@angular/common/http';
import type Keycloak from 'keycloak-js';
import { httpUrlSkipsKeycloakBearerRefresh } from './keycloak-http.config';
import { KEYCLOAK_UPDATE_MIN_VALIDITY_SECONDS } from './keycloak-refresh.constants';

/**
 * Predicado usado por `KeycloakService.init({ shouldUpdateToken })`.
 *
 * **Critério alinhado a `keycloak-js` `updateToken(minValidity)`**: só devolve true quando
 * `kc.isTokenExpired(updateMinValidity)` seria true — ou seja, quando o adapter iria mesmo
 * fazer `POST .../token`. Evita chamar `updateToken` em cada navegação enquanto o access
 * token ainda tem folga ≥ `KEYCLOAK_UPDATE_MIN_VALIDITY_SECONDS` (o mesmo valor de `init`).
 *
 * Nota: a antiga pré-validação só com `exp` + buffer fixo (35s) era **mais estrita** que o
 * keycloak-js (30s), gerando `updateToken()` sem ida à rede (overhead) e confusão em DevTools.
 */
export function shouldAttemptKeycloakTokenRefresh(
  req: HttpRequest<unknown>,
  kc: Keycloak,
  kcBase: string
): boolean {
  if (!kc.authenticated) {
    return false;
  }
  if (req.method === 'OPTIONS') {
    return false;
  }
  if (httpUrlSkipsKeycloakBearerRefresh(req.url, kcBase)) {
    return false;
  }

  try {
    if (
      typeof kc.isTokenExpired === 'function' &&
      !kc.isTokenExpired(KEYCLOAK_UPDATE_MIN_VALIDITY_SECONDS)
    ) {
      return false;
    }
  } catch {
    return true;
  }
  return true;
}
